(function () {
  function count(li) {
    var m = li.textContent.match(/\((\d+)\)/);
    return m ? parseInt(m[1], 10) : 0;
  }
  function sortVendors() {
    document.querySelectorAll('input[name$=".vendor"]').forEach(function (inp) {
      var ul = inp.closest('ul');
      if (!ul || ul.dataset.sorted === '1') return;
      var items = Array.prototype.slice.call(ul.children).filter(function (c) {
        return c.tagName === 'LI';
      });
      var visibleN = items.filter(function (li) {
        return !li.classList.contains('show-more-item');
      }).length;
      var expanded = items.some(function (li) {
        return li.classList.contains('show-more-item') && !li.classList.contains('hidden');
      });
      items.sort(function (a, b) { return count(b) - count(a); });
      items.forEach(function (li, i) {
        ul.appendChild(li);
        if (visibleN > 0 && visibleN < items.length) {
          if (i < visibleN) {
            li.classList.remove('show-more-item', 'hidden');
          } else {
            li.classList.add('show-more-item');
            li.classList.toggle('hidden', !expanded);
          }
        }
      });
      ul.dataset.sorted = '1';
    });
  }
  var t;
  function run() {
    clearTimeout(t);
    t = setTimeout(sortVendors, 50);
  }
  document.addEventListener('DOMContentLoaded', run);
  new MutationObserver(run).observe(document.documentElement, { childList: true, subtree: true });
  run();
})();